import type { ColorValue, PointsStyle } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

const DEFAULT_POINT_COLOR: ColorValue = {
  rgb: { r: 100, g: 100, b: 150, a: 1 },
};

export const pointsStyleNode: NodeDefinition = {
  type: "pointsStyle",
  label: "Point Style",
  category: "Style",
  inputs: [
    { key: "color", label: "Color", socket: "color" },
    {
      key: "size",
      label: "Size",
      socket: "number",
      control: { kind: "number", key: "size", label: "size", step: 0.1 },
    },
  ],
  outputs: [{ key: "style", label: "Style", socket: "style" }],
  controls: [],
  defaults: { size: 2 },

  compute(ctx) {
    const style: PointsStyle = {
      type: "points",
      size: ctx.number("size", 2),
      color: ctx.connected<ColorValue>("color") ?? DEFAULT_POINT_COLOR,
    };

    return { style };
  },
};
